export default "__VITE_ASSET__qwgyEPnH__"